import { cx } from "../../../utils/classNames";
import { getScaleValues } from "../performanceUtils";
import styles from "../Performance.module.css";

// Segmented min…max buttons; each value's label is its tooltip.
// Clicking the selected value again clears it.
const RatingControl = ({ scale, value, onChange, label }) => (
  <div className={styles.segmented} role="radiogroup" aria-label={label}>
    {getScaleValues(scale).map((v) => {
      const valueLabel = scale.labels?.find((l) => l.value === v)?.label;
      const isActive = value === v;
      return (
        <button
          key={v}
          type="button"
          role="radio"
          aria-checked={isActive}
          className={cx(styles.segment, isActive && styles.segmentActive)}
          title={valueLabel ? `${v} – ${valueLabel}` : String(v)}
          onClick={() => onChange(isActive ? null : v)}
        >
          {v}
        </button>
      );
    })}
  </div>
);

export default RatingControl;
